const Footer = () => {
  return (
    <footer className="flex items-end justify-center bg-navyBlue-dark font-mon xl:col-span-2">
      <p className="py-6 h-max text-gray-text1 font-semibold text-sm">
        created by <span className="font-bold underline">&R</span> -{" "}
        <span className="font-medium">devChallenges.io</span>
      </p>
    </footer>
  );
};

export default Footer;
